import { useState, useEffect, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { analyticsReports } from 'services';
import { skeletonFactory, useAzureStorage, useHandleRequest } from 'shared';
import { CONTAINERS } from 'pages/shared';

const reportDummy = skeletonFactory.analyticsReport();

export function useAnalyticsReport(id) {
  const [reportData, setReportData] = useState(id ? reportDummy : {});
  const { request, errorInfo, setErrorInfo } = useHandleRequest();
  const { uploadFile } = useAzureStorage(CONTAINERS.ANALYTICS_REPORTS);

  useEffect(() => {
    async function getData() {
      await request(async () => {
        const response = await analyticsReports.getById(id);
        if (response) {
          setReportData(response.data || {});
        }
      }, false);
    }
    id && getData();
  }, [request, id]);

  const updateReport = useCallback(
    async report => {
      await request(async () => {
        if (report.selectedFile) {
          const fileId = uuidv4();
          const urlFile = await uploadFile({ ...report.selectedFile, fileId: fileId });
          report.reportFileUrl = urlFile;
          report.reportFileMimeType = report.selectedFile.mimeType;
          report.reportFileName = report.selectedFile.path;
          report.selectedFile = null;
        }
        setReportData(report);
        await analyticsReports.update(id, report);
      });
    },
    [request, id, uploadFile]
  );

  const createReport = useCallback(
    async report => {
      await request(async () => {
        if (report.selectedFile) {
          const fileId = uuidv4();
          const urlFile = await uploadFile({ ...report.selectedFile, fileId: fileId });
          report.reportFileUrl = urlFile;
          report.reportFileMimeType = report.selectedFile.mimeType;
          report.reportFileName = report.selectedFile.path;
          report.selectedFile = null;
        }
        setReportData(report);
        await analyticsReports.create(report);
      });
    },
    [request, uploadFile]
  );

  return {
    report: reportData,
    errorInfo,
    setErrorInfo,
    setReportData,
    createReport,
    updateReport
  };
}
